export default {
    'name': 'checkmark-big',
    'width': '48',
    'height': '48',
    'viewBox': '0 0 48 48',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M43.2303 11.9724C43.6208 11.5819 43.6208 10.9487 43.2303 10.5582C42.8398 10.1677 42.2066 10.1677 41.8161 10.5582L17.0538 35.3205L6.18391 24.4506C5.79339 24.0601 5.16022 24.0601 4.7697 24.4506C4.37918 24.8411 4.37918 25.4743 4.7697 25.8648L16.3467 37.4418C16.7372 37.8323 17.3704 37.8323 17.7609 37.4418L43.2303 11.9724Z\' fill=\'#006CFD\'/>'
}
